import React, { useEffect } from "react";
import "./detailsFacture.scss";
import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { COLORS, dateFormatter, priceFormatter } from "../../settings/themeSettings";
import { Print, Update, TrendingUp } from "@mui/icons-material";
import WestIcon from '@mui/icons-material/West';
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { fetchDevis } from "../../data/slices/devisSlice";

const styles = {
    container: {
        // border: '1px solid blue',
        minHeight: '1000px',
        width: '1200px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: COLORS.gray[100],
        padding: '15px',
        borderRadius: '5px',
        height: 'fit-content'

    },
    pathtitle: {
        fontSize: '1em',
        fontWeight: 'bold',
        padding: '0 10px',
        width: '100%',
        color: COLORS.tertiary
    },
    path: {
        width: '300px',
        height: '100%',
        //  border: '1px solid red'
    }
}










const DetailsDevis = (props) => {

    const navigateTo = useNavigate();
    const { id, clientId} = useParams();
    const dispatch = useDispatch();

    const {devis, fetchDevisStatus} = useSelector((state) => state.devis)


    useEffect( () => {


        dispatch(fetchDevis(id));



    }, [dispatch, id]);










    return ( 

      (  fetchDevisStatus  === 'loading')?
        <div className="loader-container">
        <span className="loader"></span>
    </div>


        :


    
    <Box
        sx={
            styles.container
        }>

        <Stack
            direction="row"
            justifyContent="space-between"
            gap="5"
            alignItems="flex-start"

        >
            <div onClick={() => navigateTo(`/billeterie/factures/${clientId}`)}
                style={{ background: COLORS.secondary, height: '65px', width: '65px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: `${65 / 2}px`, cursor: 'pointer' }}>
                <WestIcon style={{ fill: 'white', fontSize: 28 }} />
            </div>
            <Typography variant="h4" sx={{ backgroundColor: COLORS.secondary, color: '#FFF', p: '10px', mb: 5, width: '1100px' }}>Détails devis </Typography>

        </Stack>


        <Stack

            direction="row"
            justifyContent="space-between"

            divider={
                <Box
                    component="hr"
                    sx={{
                        border: `1px solid ${COLORS.tertiary}`,
                    }}
                />
            }


        >




            <Stack sx={{ width: '30%', mb: 5 }}>
                <Typography
                    variant="p"
                    sx={styles.pathtitle}
                >
                    Détails Devis
                </Typography>


                <Stack sx={{ padding: '0 10px' }}>
                    <Typography sx={{ fontSize: 18, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <span> N° Devis:</span>       <span style={{ fontWeight: "bold", color: COLORS.secondary }} >{devis?.numeroDevis}  </span>
                    </Typography>
{/*                   
                    <Typography sx={{ fontSize: 18, width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <span style={{ fontWeight: "bold", color: COLORS.tertiary }} >Commentaire: </span>
                        <span style={{ fontSize: 14, fontWeight: "bold", color: COLORS.secondary }} >
                            {facture.commentaire}
                        </span>
                    </Typography> */}

                </Stack>





            </Stack>

            <Stack
                sx={{ width: '30%' }}
                direction="column"
                justifyContent="center"
                gap={2}
                style={{ padding: '0 20px' }}
            >
                <Button onClick={() => navigateTo(`/billeterie/devis/${clientId}/${id}/pdf`)} color="secondary" variant="outlined" startIcon={<Print />}>
                    Imprimer devis
                </Button>

                <Button 
                    color="success" 
                    variant="outlined" 
                    startIcon={<TrendingUp />}
                    onClick={() => {
                        if (window.confirm("Voulez-vous transformer ce devis en facture définitive ?")) {
                            navigateTo(`/billeterie/factures/nouveau/${clientId}`, { state: { initialData: devis } });
                        }
                    }}
                >
                    Transformer en Facture
                </Button>
           
                <Button 
                disabled={true}

                onClick={() => navigateTo(`/billeterie/devis/${clientId}/update/${id}`)} color="primary" variant="outlined" startIcon={<Update />}>
                    Modifier devis
                </Button>
            </Stack>






        </Stack>

        <Stack
            direction="row"

            divider={
                <Box
                    component="hr"
                    sx={{
                        border: `1px solid ${COLORS.tertiary}`,
                    }}
                />
            }
            sx={{ minHeight: '100px' }}


        >


            <Box xs={styles.path} width={'100%'}
            >
                <Typography
                    variant="p"
                    sx={styles.pathtitle}
                >
                    Liste des billets
                </Typography>


                <TableContainer component={Paper} sx={{ mt: '15px' }}>
                    <Table sx={{ minWidth: 450 }} aria-label="simple table">
                        <TableHead>
                            <TableRow sx={{ border: `1px solid ${COLORS.secondary}` }}>
                                <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>N° de billet</TableCell>
                                <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Nom sur le billet</TableCell>
                              <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Trajet </TableCell>
  
                                <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>N° de vol Aller</TableCell>
                                <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Date vol Aller </TableCell>
                                <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Compagnie Aller </TableCell>
                                <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>N° de vol Retour</TableCell>
                                <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Date vol Retour </TableCell>
                                <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Compagnie Retour </TableCell>
                                <TableCell sx={{ backgroundColor: COLORS.secondary, color: '#FFF' }}>Montant TTC </TableCell>
                          

                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {
                              devis?.billets?.map((billet, idx) => {
                                    return <TableRow key={idx} sx={{ color: COLORS.secondary, border: `1px solid ${COLORS.secondary}`, '& > *': { border: `1px solid ${COLORS.secondary}` } }}>
                                        <TableCell > {billet.numero} </TableCell>
                                        <TableCell > {billet.nom} </TableCell>
                                                   <TableCell > {billet.trajet} </TableCell>

                                        <TableCell > {billet.numeroVol} </TableCell>
                                        <TableCell> {dateFormatter(billet.dateVol)  } </TableCell>
                                        <TableCell > {billet.compagnie} </TableCell>

                                        <TableCell > {billet.numeroVolRetour} </TableCell>
                                        <TableCell> {dateFormatter(billet.dateVolRetour ) } </TableCell>
                                        <TableCell > {billet.compagnieRetour} </TableCell>
                                        <TableCell > {priceFormatter(billet.tarif) } </TableCell>
                                    
                                    </TableRow>

                                })

                            }

                        </TableBody>
                    </Table>
                </TableContainer>


            </Box>

        </Stack>

     


    </Box>
    )
    
}



export default DetailsDevis;
